import styled from "styled-components";

export const GSPSFormControlStyled = styled.div`
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #8cfad0 !important;
    border-width: 1px !important;
  }
  & .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    padding-right: 0px;
    border: 1px solid #E8E7F5;
    margin-bottom: 16px;
  }

  & #issue_severity,
  & #item_phase,
  & #audit_type_item_id,
  & #custom_color {
    display: flex;
    align-items: center;
    padding: 10px 5px;
  }
`;
